export const screeningInnerRoutePaths = {
  storiesList: 'listagem-inscricoes',
  storyResume: 'resumo-inscricao',
} as const;

export const screeningRoutePaths = {
  home: '/triagem',
  storiesList: `/triagem/${screeningInnerRoutePaths.storiesList}`,
  storyResume: `/triagem/${screeningInnerRoutePaths.storyResume}/:id`,
} as const;

export function screeningStoryResumePath(id?: number): string {
  return screeningRoutePaths.storyResume.replace(':id', id + '');
}
